module.exports = __webpack_public_path__ + "img/Search.61786fc6.svg";